/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Information about a single feature according to the current feature configuration.
 */
export type FeatureResponse = {
    /**
     * The identifier of the feature.
     */
    feature: FeatureResponse.feature;
    /**
     * A textual description of the feature.
     */
    description: string;
    /**
     * The current status of the feature.
     */
    status: FeatureResponse.status;
};

export namespace FeatureResponse {

    /**
     * The identifier of the feature.
     */
    export enum feature {
        IDENTITY_VERIFICATION_OPTIONAL = 'IDENTITY_VERIFICATION_OPTIONAL',
        TEST_STRIPS = 'TEST_STRIPS',
        TRUEPILL_INTEGRATION = 'TRUEPILL_INTEGRATION',
        ELIGIBILITY_UNLISTED_MED = 'ELIGIBILITY_UNLISTED_MED',
        ZENDESK_USER_REQUIRES_ASSISTANCE_EVENTS = 'ZENDESK_USER_REQUIRES_ASSISTANCE_EVENTS',
        SHIPMENT_PAYMENT_BLOCKING = 'SHIPMENT_PAYMENT_BLOCKING',
        SUBSCRIPTION_ACTIVATED_IMMEDIATELY = 'SUBSCRIPTION_ACTIVATED_IMMEDIATELY',
        SUBSCRIPTION_ONBOARDING_FEE = 'SUBSCRIPTION_ONBOARDING_FEE',
        SUBSCRIPTION_SKIP_PAYMENT_PROVIDER_FOR_NON_PAYABLE = 'SUBSCRIPTION_SKIP_PAYMENT_PROVIDER_FOR_NON_PAYABLE',
        SUBSCRIPTION_SELF_SERVICE_CASHPAY_SWITCH = 'SUBSCRIPTION_SELF_SERVICE_CASHPAY_SWITCH',
        GENERIC_PRESCRIPTION = 'GENERIC_PRESCRIPTION',
        ELIGIBILITY_GROUP = 'ELIGIBILITY_GROUP',
        HUB_SPOT_ANALYTICS_DESTINATION = 'HUB_SPOT_ANALYTICS_DESTINATION',
        AT_HOME_PHLEBOTOMY_RULE_BASED_LAB_CADENCE = 'AT_HOME_PHLEBOTOMY_RULE_BASED_LAB_CADENCE',
        DRY_BLOOD_SPOT_RULE_BASED_LAB_CADENCE = 'DRY_BLOOD_SPOT_RULE_BASED_LAB_CADENCE',
        LAB_ORDER_TRIGGERING_DRY_RUN = 'LAB_ORDER_TRIGGERING_DRY_RUN',
        LAB_CADENCE_RULES_A1C = 'LAB_CADENCE_RULES_A1C',
        LAB_CADENCE_RULES_CMP = 'LAB_CADENCE_RULES_CMP',
        LAB_CADENCE_RULES_INITIAL_CMP_FOR_WEIGHT_LOSS_USERS = 'LAB_CADENCE_RULES_INITIAL_CMP_FOR_WEIGHT_LOSS_USERS',
        LAB_CADENCE_RULES_LIPIDS = 'LAB_CADENCE_RULES_LIPIDS',
        LAB_CADENCE_RULES_URINARY_MICROALBUMIN_TO_CREATININE_RATIO = 'LAB_CADENCE_RULES_URINARY_MICROALBUMIN_TO_CREATININE_RATIO',
        LAB_CADENCE_RULES_TSH = 'LAB_CADENCE_RULES_TSH',
        LAB_CADENCE_RULES_LIPOPROTEIN_A = 'LAB_CADENCE_RULES_LIPOPROTEIN_A',
        LAB_CADENCE_RULES_PLATELET_COUNT = 'LAB_CADENCE_RULES_PLATELET_COUNT',
        LAB_CADENCE_CREATININE_AS_CMP = 'LAB_CADENCE_CREATININE_AS_CMP',
        DOSE_SPOT_INTEGRATION = 'DOSE_SPOT_INTEGRATION',
        DOSE_SPOT_API_V2_LOG_REQUESTS = 'DOSE_SPOT_API_V2_LOG_REQUESTS',
        DOSE_SPOT_MEDICATION_SEARCH_ONLY_RETURN_FIRST_PAGE = 'DOSE_SPOT_MEDICATION_SEARCH_ONLY_RETURN_FIRST_PAGE',
        GETLABS_AT_HOME_PHLEBOTOMY = 'GETLABS_AT_HOME_PHLEBOTOMY',
        PRESCRIBING_MEDICAL_SUPPLIES = 'PRESCRIBING_MEDICAL_SUPPLIES',
        WEIGHT_LOSS_GLP1_TRIAL = 'WEIGHT_LOSS_GLP1_TRIAL',
        PUSH_NOTIFICATIONS_ANDROID_VIA_FIREBASE = 'PUSH_NOTIFICATIONS_ANDROID_VIA_FIREBASE',
        PUSH_NOTIFICATIONS_VIA_CUSTOMERIO = 'PUSH_NOTIFICATIONS_VIA_CUSTOMERIO',
        LAB_ITEM_AUTOMATIC_UPDATE = 'LAB_ITEM_AUTOMATIC_UPDATE',
        LAB_ITEM_AUTOMATIC_UPDATE_TRIGGER = 'LAB_ITEM_AUTOMATIC_UPDATE_TRIGGER',
        PRESCRIPTION_DIAGNOSIS_CODES = 'PRESCRIPTION_DIAGNOSIS_CODES',
        HIDE_INSULIN_SIGS = 'HIDE_INSULIN_SIGS',
        PRESCRYPTIVE = 'PRESCRYPTIVE',
        EVERNORTH = 'EVERNORTH',
        CONSULTATION_COMPLETED_LIFELINE_ITEM = 'CONSULTATION_COMPLETED_LIFELINE_ITEM',
        CONSULTATION_AUTO_PREPARE_SYNC_VISIT = 'CONSULTATION_AUTO_PREPARE_SYNC_VISIT',
        CONSULTATION_AUTO_CANCEL_SYNC_VISIT = 'CONSULTATION_AUTO_CANCEL_SYNC_VISIT',
        CONSULTATION_AUTO_HANDLE_INACTIVE_PHARMACIES = 'CONSULTATION_AUTO_HANDLE_INACTIVE_PHARMACIES',
        CHANGE_HEALTHCARE_INTEGRATION = 'CHANGE_HEALTHCARE_INTEGRATION',
        CHANGE_HEALTHCARE_FORCE_SESSION_ID_RESET = 'CHANGE_HEALTHCARE_FORCE_SESSION_ID_RESET',
        CHANGE_HEALTHCARE_LABCORP_INTEGRATION = 'CHANGE_HEALTHCARE_LABCORP_INTEGRATION',
        CHANGE_HEALTHCARE_QUEST_INTEGRATION = 'CHANGE_HEALTHCARE_QUEST_INTEGRATION',
        CHANGE_HEALTHCARE_LAB_RESULTS = 'CHANGE_HEALTHCARE_LAB_RESULTS',
        CHANGE_HEALTHCARE_AUTO_TRIGGERING = 'CHANGE_HEALTHCARE_AUTO_TRIGGERING',
        PMP_PCP = 'PMP_PCP',
        FILES_SCAN_FOR_VIRUSES = 'FILES_SCAN_FOR_VIRUSES',
        FILES_ALWAYS_GENERATE_ZENDESK_TICKET = 'FILES_ALWAYS_GENERATE_ZENDESK_TICKET',
        PMP_FAX = 'PMP_FAX',
        PASSWORD_EXPIRATION = 'PASSWORD_EXPIRATION',
        SMARTMETERRPM_INTEGRATION = 'SMARTMETERRPM_INTEGRATION',
        SMARTMETERRPM_ENFORCE_SIGNATURE_VERIFICATION = 'SMARTMETERRPM_ENFORCE_SIGNATURE_VERIFICATION',
        SMARTMETERRPM_TRIGGER_DEVICE_SHIPMENTS = 'SMARTMETERRPM_TRIGGER_DEVICE_SHIPMENTS',
        WITHINGS_TRIGGER_DEVICE_SHIPMENTS = 'WITHINGS_TRIGGER_DEVICE_SHIPMENTS',
        WITHINGS_TEST_MODE = 'WITHINGS_TEST_MODE',
        SCALE_ADD_AUTOMATICALLY_TO_SUBSCRIPTION = 'SCALE_ADD_AUTOMATICALLY_TO_SUBSCRIPTION',
        SCALE_ADD_AUTOMATICALLY_TO_SUBSCRIPTION_FOR_TRANSCARENT_MEMBER = 'SCALE_ADD_AUTOMATICALLY_TO_SUBSCRIPTION_FOR_TRANSCARENT_MEMBER',
        BPM_ADD_AUTOMATICALLY_TO_SUBSCRIPTION = 'BPM_ADD_AUTOMATICALLY_TO_SUBSCRIPTION',
        USE_WITHINGS_SCALE_SKU = 'USE_WITHINGS_SCALE_SKU',
        SMARTMETERPM_SUSPEND_DEVICES = 'SMARTMETERPM_SUSPEND_DEVICES',
        SMARTMETERPM_ACTIVATE_DEVICES = 'SMARTMETERPM_ACTIVATE_DEVICES',
        CASHPAY_GENERIC_FUNNEL = 'CASHPAY_GENERIC_FUNNEL',
        DEMO_DATA = 'DEMO_DATA',
        END_USER_MFA_TOTP = 'END_USER_MFA_TOTP',
        AUTOMATIC_DETECTION_OF_CONSULT_REASON = 'AUTOMATIC_DETECTION_OF_CONSULT_REASON',
        ONBOARDING_TASK_UPLOAD_LAB_REPORT = 'ONBOARDING_TASK_UPLOAD_LAB_REPORT',
        ONBOARDING_TASK_SELECT_PCP = 'ONBOARDING_TASK_SELECT_PCP',
        ONBOARDING_TASK_SELECT_PHARMACY_INSURANCE = 'ONBOARDING_TASK_SELECT_PHARMACY_INSURANCE',
        ONBOARDING_TASK_ANSWER_POSTSIGNUP_QUESTIONNAIRE = 'ONBOARDING_TASK_ANSWER_POSTSIGNUP_QUESTIONNAIRE',
        ONBOARDING_TASK_SELECT_PREFERRED_PHARMACY = 'ONBOARDING_TASK_SELECT_PREFERRED_PHARMACY',
        ONBOARDING_TASK_ANSWER_INITIAL_LABS_QUESTIONNAIRE = 'ONBOARDING_TASK_ANSWER_INITIAL_LABS_QUESTIONNAIRE',
        ONBOARDING_TASK_SCHEDULE_INITIAL_SYNC_VISIT = 'ONBOARDING_TASK_SCHEDULE_INITIAL_SYNC_VISIT',
        ONBOARDING_TASK_COMPLETE_INITIAL_LAB_ORDER = 'ONBOARDING_TASK_COMPLETE_INITIAL_LAB_ORDER',
        ONBOARDING_TASK_SELECT_MEDICAL_INSURANCE = 'ONBOARDING_TASK_SELECT_MEDICAL_INSURANCE',
        ONBOARDING_TASK_COMPLETE_ONBOARDING = 'ONBOARDING_TASK_COMPLETE_ONBOARDING',
        ONBOARDING_TASK_GLP1_CONTINUATION = 'ONBOARDING_TASK_GLP1_CONTINUATION',
        CHECKIN_TASK_ANSWER_RECURRING_CHECKIN_QUESTIONNAIRE = 'CHECKIN_TASK_ANSWER_RECURRING_CHECKIN_QUESTIONNAIRE',
        RECURRING_TASK_SCHEDULE_FOLLOWUP_SYNC_VISIT = 'RECURRING_TASK_SCHEDULE_FOLLOWUP_SYNC_VISIT',
        ENFORCE_LAB_ORDER_INSURANCE_BILL = 'ENFORCE_LAB_ORDER_INSURANCE_BILL',
        SYNC_CONSULTATION = 'SYNC_CONSULTATION',
        CARE_TASK_SCHEDULE_LABS_APPOINTMENT = 'CARE_TASK_SCHEDULE_LABS_APPOINTMENT',
        CARE_TASK_RECURRING_LABS = 'CARE_TASK_RECURRING_LABS',
        CARE_TASK_RECURRING_INITIAL_LAB_QUESTIONNAIRE = 'CARE_TASK_RECURRING_INITIAL_LAB_QUESTIONNAIRE',
        CARE_TASK_WAIST_MEASUREMENT = 'CARE_TASK_WAIST_MEASUREMENT',
        CARE_TASK_STEP_ON_SCALE_WEEKLY = 'CARE_TASK_STEP_ON_SCALE_WEEKLY',
        INITIAL_ORDER_ONLY_CONSULTATION = 'INITIAL_ORDER_ONLY_CONSULTATION',
        AI_EXPERIMENT_RECOMMEND_THERAPY_CHANGE = 'AI_EXPERIMENT_RECOMMEND_THERAPY_CHANGE',
        AI_EXPERIMENT_PRIOR_SYNC_VISIT_NOTES_V3 = 'AI_EXPERIMENT_PRIOR_SYNC_VISIT_NOTES_V3',
        AI_EXPERIMENT_PRIOR_AUTH_LETTER = 'AI_EXPERIMENT_PRIOR_AUTH_LETTER',
        AI_EXPERIMENT_CAREASSISTANT_HTN = 'AI_EXPERIMENT_CAREASSISTANT_HTN',
        AI_EXPERIMENT_CAREASSISTANT_STATIN = 'AI_EXPERIMENT_CAREASSISTANT_STATIN',
        AI_EXPERIMENT_APPOINTMENT_SUMMARY = 'AI_EXPERIMENT_APPOINTMENT_SUMMARY',
        AI_EXPERIMENT_PATIENT_AMA = 'AI_EXPERIMENT_PATIENT_AMA',
        AI_MEMBER_AMA_VECTOR_STORE_AS_TOOL = 'AI_MEMBER_AMA_VECTOR_STORE_AS_TOOL',
        AI_MEMBER_AMA_MODEL_OVERRIDES = 'AI_MEMBER_AMA_MODEL_OVERRIDES',
        AI_MEMBER_AMA_DPP_VARIANT = 'AI_MEMBER_AMA_DPP_VARIANT',
        AI_MEMBER_AMA_SMS_CHANNEL = 'AI_MEMBER_AMA_SMS_CHANNEL',
        AI_INCLUDE_CONSULTATION_NOTES_IN_PROGRESS_NOTES = 'AI_INCLUDE_CONSULTATION_NOTES_IN_PROGRESS_NOTES',
        AI_PROGRESS_NOTE_SUMMARY = 'AI_PROGRESS_NOTE_SUMMARY',
        AI_EXPERIMENT_TRIAGE_MESSAGE = 'AI_EXPERIMENT_TRIAGE_MESSAGE',
        WELCOME_MESSAGE_VIA_BACKEND = 'WELCOME_MESSAGE_VIA_BACKEND',
        PARTNER_ELIGIBILITY_EXEMPTION = 'PARTNER_ELIGIBILITY_EXEMPTION',
        CONNECTIVE_HEALTH_INTEGRATION = 'CONNECTIVE_HEALTH_INTEGRATION',
        CONNECTIVE_HEALTH_SIMULATE_RESULTS = 'CONNECTIVE_HEALTH_SIMULATE_RESULTS',
        CONNECTIVE_HEALTH_SIMULATE_RESULTS_V2 = 'CONNECTIVE_HEALTH_SIMULATE_RESULTS_V2',
        GOOGLE_HEALTH_CONNECT_SIMULATE_RESULTS = 'GOOGLE_HEALTH_CONNECT_SIMULATE_RESULTS',
        APPLE_HEALTH_CONNECT_SIMULATE_RESULTS = 'APPLE_HEALTH_CONNECT_SIMULATE_RESULTS',
        CONNECTIVE_HEALTH_AUTOMATIC_QUARTERLY_PULLS = 'CONNECTIVE_HEALTH_AUTOMATIC_QUARTERLY_PULLS',
        CONNECTIVE_HEALTH_SEND_ENCOUNTERS = 'CONNECTIVE_HEALTH_SEND_ENCOUNTERS',
        CONNECTIVE_HEALTH_USE_CONDITIONS = 'CONNECTIVE_HEALTH_USE_CONDITIONS',
        APERO_HEALTH_INTEGRATION = 'APERO_HEALTH_INTEGRATION',
        APERO_ELIGIBILITY_CHECK = 'APERO_ELIGIBILITY_CHECK',
        APERO_USE_VIDEO_LINKS = 'APERO_USE_VIDEO_LINKS',
        APERO_SYNCHRONIZE_PROVIDER_QUALIFICATIONS = 'APERO_SYNCHRONIZE_PROVIDER_QUALIFICATIONS',
        TRANSCARENT_SSO = 'TRANSCARENT_SSO',
        TRANSCARENT_SHARE_DATA = 'TRANSCARENT_SHARE_DATA',
        TRANSCARENT_BARIATRIC_SURGERY = 'TRANSCARENT_BARIATRIC_SURGERY',
        TRANSCARENT_MEDICATION_CARVE_OUT = 'TRANSCARENT_MEDICATION_CARVE_OUT',
        TRANSCARENT_SUPPRESS_EMAILS = 'TRANSCARENT_SUPPRESS_EMAILS',
        TRANSCARENT_USE_HEALTH_CONDITIONS = 'TRANSCARENT_USE_HEALTH_CONDITIONS',
        TRANSCARENT_LOAD_INSURANCE_DATA = 'TRANSCARENT_LOAD_INSURANCE_DATA',
        TRANSCARENT_REFRESH_INSURANCE_DATA = 'TRANSCARENT_REFRESH_INSURANCE_DATA',
        TRANSCARENT_ELIGIBILITY_CHECK_VIA_API = 'TRANSCARENT_ELIGIBILITY_CHECK_VIA_API',
        RPM_ORDER = 'RPM_ORDER',
        PROVIDER_CAN_ADD_SERVICE_REQUEST = 'PROVIDER_CAN_ADD_SERVICE_REQUEST',
        CRL_LAB_RESULTS = 'CRL_LAB_RESULTS',
        ONBOARDING_REQUEST_CALLBACK = 'ONBOARDING_REQUEST_CALLBACK',
        PMP_BILLING_ADDRESS_EDITING = 'PMP_BILLING_ADDRESS_EDITING',
        RXDIET_TASK_CREATE_MEAL_PLAN = 'RXDIET_TASK_CREATE_MEAL_PLAN',
        PATH_TO_HEALTHY_WEIGHT_PROGRAM = 'PATH_TO_HEALTHY_WEIGHT_PROGRAM',
        UNWRAP_ASYNC_MESSAGE_PROCESSING_EXCEPTION_LOGGING = 'UNWRAP_ASYNC_MESSAGE_PROCESSING_EXCEPTION_LOGGING',
        AMAZON_WEIGHTLOSS = 'AMAZON_WEIGHTLOSS',
        AMAZON_APERO_SETUP = 'AMAZON_APERO_SETUP',
        HANDLE_OBSERVATIONSAVED_EVENTS = 'HANDLE_OBSERVATIONSAVED_EVENTS',
        HANDLE_USERANSWEREDQUESTIONNAIRE_EVENTS = 'HANDLE_USERANSWEREDQUESTIONNAIRE_EVENTS',
        RXDIET_COMPLETE_MEAL_PLAN_JOB = 'RXDIET_COMPLETE_MEAL_PLAN_JOB',
        RXDIET_ANALYTICS_PROFILE_PROVIDER = 'RXDIET_ANALYTICS_PROFILE_PROVIDER',
        AMAZON_ELIGIBILITY_FILE_DOWNLOAD = 'AMAZON_ELIGIBILITY_FILE_DOWNLOAD',
        AMAZON_TEST_ELIGIBILITY_FILE_DOWNLOAD = 'AMAZON_TEST_ELIGIBILITY_FILE_DOWNLOAD',
        KWIKTRIP_ELIGIBILITY_FILE_DOWNLOAD = 'KWIKTRIP_ELIGIBILITY_FILE_DOWNLOAD',
        KWIK_TRIP_CENTER_FOR_HEALTH_LAB_ORDER_PROVIDER = 'KWIK_TRIP_CENTER_FOR_HEALTH_LAB_ORDER_PROVIDER',
        SMITHRX_ELIGIBILITY_FILE_DOWNLOAD = 'SMITHRX_ELIGIBILITY_FILE_DOWNLOAD',
        SMITHRX_FRESENIUS_ELIGIBILITY_FILE_DOWNLOAD = 'SMITHRX_FRESENIUS_ELIGIBILITY_FILE_DOWNLOAD',
        EVERNORTH_ELIGIBILITY_FILE_DOWNLOAD = 'EVERNORTH_ELIGIBILITY_FILE_DOWNLOAD',
        EVERNORTH_PILOT_ELIGIBILITY_FILE_DOWNLOAD = 'EVERNORTH_PILOT_ELIGIBILITY_FILE_DOWNLOAD',
        AMAZON_COBRA_ELIGIBILITY_FILE_DOWNLOAD = 'AMAZON_COBRA_ELIGIBILITY_FILE_DOWNLOAD',
        SHBP_GEORGIA_ELIGIBILITY_FILE_DOWNLOAD = 'SHBP_GEORGIA_ELIGIBILITY_FILE_DOWNLOAD',
        SHBP_GEORGIA_CVS_RX_CLAIMS_FILE_DOWNLOAD = 'SHBP_GEORGIA_CVS_RX_CLAIMS_FILE_DOWNLOAD',
        SHBP_GEORGIA_APERO_INSURANCE_VERIFICATION = 'SHBP_GEORGIA_APERO_INSURANCE_VERIFICATION',
        PREVENT_INELIGIBLE_SIGN_UP = 'PREVENT_INELIGIBLE_SIGN_UP',
        PROVIDE_PARTIAL_ELIGIBILITY_MATCHES = 'PROVIDE_PARTIAL_ELIGIBILITY_MATCHES',
        PRE_SIGN_UP_ELIGIBILITY_CHECK_AMAZON = 'PRE_SIGN_UP_ELIGIBILITY_CHECK_AMAZON',
        PRE_SIGN_UP_ELIGIBILITY_CHECK_WIPFLI = 'PRE_SIGN_UP_ELIGIBILITY_CHECK_WIPFLI',
        PRE_SIGN_UP_ELIGIBILITY_CHECK_KWIKTRIP = 'PRE_SIGN_UP_ELIGIBILITY_CHECK_KWIKTRIP',
        PRE_SIGN_UP_ELIGIBILITY_CHECK_SMITHRX = 'PRE_SIGN_UP_ELIGIBILITY_CHECK_SMITHRX',
        PRE_SIGN_UP_ELIGIBILITY_CHECK_EVERNORTH = 'PRE_SIGN_UP_ELIGIBILITY_CHECK_EVERNORTH',
        PRE_SIGN_UP_ELIGIBILITY_CHECK_SOLERA = 'PRE_SIGN_UP_ELIGIBILITY_CHECK_SOLERA',
        PRE_SIGN_UP_ELIGIBILITY_CHECK_BJ_WAREHOUSE = 'PRE_SIGN_UP_ELIGIBILITY_CHECK_BJ_WAREHOUSE',
        PRE_SIGN_UP_ELIGIBILITY_CHECK_SHBP_GEORGIA = 'PRE_SIGN_UP_ELIGIBILITY_CHECK_SHBP_GEORGIA',
        PROFILE_CACHE_IN_GET_REQUESTS = 'PROFILE_CACHE_IN_GET_REQUESTS',
        CREATE_INITIAL_APPLICATION_TASK = 'CREATE_INITIAL_APPLICATION_TASK',
        ONBOARDING_AUTO_SKIP_TASK_UPLOAD_LAB_REPORT = 'ONBOARDING_AUTO_SKIP_TASK_UPLOAD_LAB_REPORT',
        APPOINTMENT_AUTO_ADD_VIDEO_LINKS = 'APPOINTMENT_AUTO_ADD_VIDEO_LINKS',
        APPOINTMENT_AUTO_MARK_AS_NO_SHOW = 'APPOINTMENT_AUTO_MARK_AS_NO_SHOW',
        APPOINTMENT_AUTO_MARK_AS_COMPLETED = 'APPOINTMENT_AUTO_MARK_AS_COMPLETED',
        APPOINTMENT_LIMIT_AVAILABLE_SLOTS = 'APPOINTMENT_LIMIT_AVAILABLE_SLOTS',
        APPOINTMENT_PATIENT_CHAT_NOTIFICATIONS = 'APPOINTMENT_PATIENT_CHAT_NOTIFICATIONS',
        APPOINTMENT_PATIENT_EMAIL_NOTIFICATIONS = 'APPOINTMENT_PATIENT_EMAIL_NOTIFICATIONS',
        APPOINTMENT_PATIENT_SMS_NOTIFICATIONS = 'APPOINTMENT_PATIENT_SMS_NOTIFICATIONS',
        APPOINTMENT_ALERT_NOTIFICATIONS = 'APPOINTMENT_ALERT_NOTIFICATIONS',
        SMARTMETERRPM_AUTO_ADD_DEVICE = 'SMARTMETERRPM_AUTO_ADD_DEVICE',
        SCHEDULING_APPOINTMENT_TASK_GROUP = 'SCHEDULING_APPOINTMENT_TASK_GROUP',
        B2B_APPOINTMENT_CADENCE = 'B2B_APPOINTMENT_CADENCE',
        SCHEDULING_DIRECT = 'SCHEDULING_DIRECT',
        CREATE_GLP1_REFILL_TASK = 'CREATE_GLP1_REFILL_TASK',
        PRE_GLP1_WEIGHT_FALLBACK = 'PRE_GLP1_WEIGHT_FALLBACK',
        AUTO_SEND_CLINICAL_SUMMARY_TO_PCP = 'AUTO_SEND_CLINICAL_SUMMARY_TO_PCP',
        ZOOM_RECORDING_AUTO_DELETE = 'ZOOM_RECORDING_AUTO_DELETE',
        SENTRY_FILTER_DUPLICATE_ENTITY_EVENTS = 'SENTRY_FILTER_DUPLICATE_ENTITY_EVENTS',
        ONBOARDING_TASK_SCHEDULE_INITIAL_PRE_ONBOARDING_SYNC_VISIT = 'ONBOARDING_TASK_SCHEDULE_INITIAL_PRE_ONBOARDING_SYNC_VISIT',
        ONBOARDING_TASK_COMPLETE_PRE_ONBOARDING = 'ONBOARDING_TASK_COMPLETE_PRE_ONBOARDING',
        ALLOW_USER_TO_PAUSE_LAB_CADENCE = 'ALLOW_USER_TO_PAUSE_LAB_CADENCE',
        GENERATE_CRL_HTML_LAB_REPORT = 'GENERATE_CRL_HTML_LAB_REPORT',
        MEAL_INSIGHTS = 'MEAL_INSIGHTS',
        SUPPRESS_MEDICATION_DEVICES_REMOVED_ZENDESK_TICKETS = 'SUPPRESS_MEDICATION_DEVICES_REMOVED_ZENDESK_TICKETS',
        MESSAGE_DRAFT_PATIENT_MESSAGE_AFTER_LAB_RESULTS_REVIEW = 'MESSAGE_DRAFT_PATIENT_MESSAGE_AFTER_LAB_RESULTS_REVIEW',
        MESSAGE_DRAFT_PATIENT_MESSAGE_AFTER_PROGRESS_NOTE = 'MESSAGE_DRAFT_PATIENT_MESSAGE_AFTER_PROGRESS_NOTE',
        WEIGHT_VALUES_CLEANUP = 'WEIGHT_VALUES_CLEANUP',
        DAILY_WEIGHT_VALUES_CLEANUP = 'DAILY_WEIGHT_VALUES_CLEANUP',
        FULL_WEIGHT_VALUES_CLEANUP = 'FULL_WEIGHT_VALUES_CLEANUP',
        PHARMACY_NOTIFY_MEMBERS_ABOUT_INACTIVE_PREFERRED_PHARMACY = 'PHARMACY_NOTIFY_MEMBERS_ABOUT_INACTIVE_PREFERRED_PHARMACY',
        INTERNAL_LINK_SHORTENER = 'INTERNAL_LINK_SHORTENER',
        PARTNERS_AUTO_CANCEL_ON_INELIGIBILITY = 'PARTNERS_AUTO_CANCEL_ON_INELIGIBILITY',
        CONSISTENCY_SCORE = 'CONSISTENCY_SCORE',
        SHBP_GEORGIA_GOLD_CARD = 'SHBP_GEORGIA_GOLD_CARD',
        BANK_OF_NEW_YORK_GOLD_CARD = 'BANK_OF_NEW_YORK_GOLD_CARD',
        APPLE_GOLD_CARD = 'APPLE_GOLD_CARD',
        OSF_HEALTH_CARE_LAB_ORDER_PROVIDER = 'OSF_HEALTH_CARE_LAB_ORDER_PROVIDER',
        TASSO_LAB_ORDER_PROVIDER = 'TASSO_LAB_ORDER_PROVIDER',
        TASSO_FOR_AMAZON = 'TASSO_FOR_AMAZON',
        OMM_SEND_PHARMACY_INSURANCE_VIA_DOSESPOT = 'OMM_SEND_PHARMACY_INSURANCE_VIA_DOSESPOT',
        DETECTED_ISSUE_TICKET = 'DETECTED_ISSUE_TICKET',
        LAB_RESULTS_SKIP_ZENDESK_TICKET_FOR_NORMAL_RANGES = 'LAB_RESULTS_SKIP_ZENDESK_TICKET_FOR_NORMAL_RANGES',
        LAB_RESULTS_AUTO_EXTRACTION = 'LAB_RESULTS_AUTO_EXTRACTION',
        CANCEL_ONGOING_LAB_ORDERS_ON_INITIAL_LAB_ORDER_SKIP = 'CANCEL_ONGOING_LAB_ORDERS_ON_INITIAL_LAB_ORDER_SKIP',
        LAB_RESULTS_AUTO_REVIEW = 'LAB_RESULTS_AUTO_REVIEW',
        SUBSCRIPTION_PURCHASE_ITEMS_SKIP_AUTO_EXPIRE_FOR_AUTO_REFILL_ITEMS = 'SUBSCRIPTION_PURCHASE_ITEMS_SKIP_AUTO_EXPIRE_FOR_AUTO_REFILL_ITEMS',
        SKIP_SYNC_VISIT_FOR_GLP1_CONTINUATION = 'SKIP_SYNC_VISIT_FOR_GLP1_CONTINUATION',
        CONVERSATION_AUTO_SUMMARIZE = 'CONVERSATION_AUTO_SUMMARIZE',
        CONVERSATION_2026_MEMBER = 'CONVERSATION_2026_MEMBER',
        CONVERSATION_ESCALATION_SYNC_ZENDESK = 'CONVERSATION_ESCALATION_SYNC_ZENDESK',
        CONVERSATION_ESCALATION_CREATE_FROM_ZENDESK = 'CONVERSATION_ESCALATION_CREATE_FROM_ZENDESK',
        NOTIFICATION_MESSAGES_AUTO_CREATE = 'NOTIFICATION_MESSAGES_AUTO_CREATE',
        CONVERSATION_AUTO_CREATE_PROGRESS_NOTE = 'CONVERSATION_AUTO_CREATE_PROGRESS_NOTE',
        LYRA_INTEGRATION = 'LYRA_INTEGRATION',
        AI_MEMBER_AMA_INCLUDE_CH_STATUS_IN_SYSTEM_PROMPT = 'AI_MEMBER_AMA_INCLUDE_CH_STATUS_IN_SYSTEM_PROMPT',
        AUTO_GLP1_MEDICATION_CONTINUATION_CONSULT = 'AUTO_GLP1_MEDICATION_CONTINUATION_CONSULT',
        CARE_CONTINUATION_PROOF_OF_WEIGHT_AI_VERIFICATION = 'CARE_CONTINUATION_PROOF_OF_WEIGHT_AI_VERIFICATION',
        EMF_EVENT_HANDLER_METRICS = 'EMF_EVENT_HANDLER_METRICS',
        CARE_CONTINUATION_COMPLETE_PRESCRIPTION_LABEL_BASED_ON_DRUG_CLASS = 'CARE_CONTINUATION_COMPLETE_PRESCRIPTION_LABEL_BASED_ON_DRUG_CLASS',
        TASKS_AUTO_SKIP = 'TASKS_AUTO_SKIP',
        UPDATE_TASKS_BATCH_JOB = 'UPDATE_TASKS_BATCH_JOB',
        QUESTIONNAIRE_ANSWER_VALUE_VALIDATION_ENFORCE = 'QUESTIONNAIRE_ANSWER_VALUE_VALIDATION_ENFORCE',
        QUESTIONNAIRE_ANSWER_VALUE_VALIDATION_ENFORCE_IN_SESSION = 'QUESTIONNAIRE_ANSWER_VALUE_VALIDATION_ENFORCE_IN_SESSION',
        SCHEDULED_ELIGIBILITY_CHECK_BATCH_JOB = 'SCHEDULED_ELIGIBILITY_CHECK_BATCH_JOB',
        RXCUI_STRICT_DESERIALIZATION = 'RXCUI_STRICT_DESERIALIZATION',
        GLP1_FIRST_INJECTION_DATE_MISSION = 'GLP1_FIRST_INJECTION_DATE_MISSION',
        GLP1_RENEWAL_MISSION = 'GLP1_RENEWAL_MISSION',
        UNLOCK_SYNC_VISIT = 'UNLOCK_SYNC_VISIT',
        LAB_ORDER_INITIATION_BATCH_JOB = 'LAB_ORDER_INITIATION_BATCH_JOB',
        SMITHRX_OMM_INSURANCE_SYNC_SCHEDULED_CHECKS = 'SMITHRX_OMM_INSURANCE_SYNC_SCHEDULED_CHECKS',
        CASE_MANAGEMENT = 'CASE_MANAGEMENT',
        CASE_MANAGEMENT_CONVERSATION_ESCALATIONS = 'CASE_MANAGEMENT_CONVERSATION_ESCALATIONS',
        CASE_MANAGEMENT_MEDICATION_REFILL_REQUESTS = 'CASE_MANAGEMENT_MEDICATION_REFILL_REQUESTS',
        CASE_MANAGEMENT_CARE_TEAM_INSTRUCTIONS = 'CASE_MANAGEMENT_CARE_TEAM_INSTRUCTIONS',
        CASE_MANAGEMENT_CONSULTATION_UNFINISHED_FOLLOWUP_ACTIONS = 'CASE_MANAGEMENT_CONSULTATION_UNFINISHED_FOLLOWUP_ACTIONS',
        CASE_MANAGEMENT_USER_REQUIRES_ASSISTANCE = 'CASE_MANAGEMENT_USER_REQUIRES_ASSISTANCE',
        CARE_SECURE_FILE_DELIVERY = 'CARE_SECURE_FILE_DELIVERY',
        CLINICAL_SUMMARY_VIA_MEDICAL_RECORD_EXPORT = 'CLINICAL_SUMMARY_VIA_MEDICAL_RECORD_EXPORT',
        LIFELINE_DELETE_PROGRESS_NOTE = 'LIFELINE_DELETE_PROGRESS_NOTE',
        RENEWAL_DECOUPLING = 'RENEWAL_DECOUPLING',
        AI_MEMBER_SYMPTOM_REPORTING = 'AI_MEMBER_SYMPTOM_REPORTING',
        AI_MEMBER_SYMPTOM_REPORTING_CONCISE_PROMPT = 'AI_MEMBER_SYMPTOM_REPORTING_CONCISE_PROMPT',
        PARTNER_LIFECYCLE_ELIGIBILITY_ENFORCEMENT = 'PARTNER_LIFECYCLE_ELIGIBILITY_ENFORCEMENT',
        BUG_REPORT_FORM_V2 = 'BUG_REPORT_FORM_V2',
        AI_MEMBER_AMA_MEAL_INSIGHTS = 'AI_MEMBER_AMA_MEAL_INSIGHTS',
        PERSONIFY_SSO = 'PERSONIFY_SSO',
        PERSONIFY_SSO_WITHOUT_MEMBER_PROFILE = 'PERSONIFY_SSO_WITHOUT_MEMBER_PROFILE',
    }

    /**
     * The current status of the feature.
     */
    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
    }


}

